/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_BOX_DETAIL = gql`
  query GetBox($filter: UniqBoxFilterInput!) {
    getBox(filter: $filter) {
      band {
        id
        name
      }
      collectorProfile {
        collectorType
        name
      }
      comments
      contentStatus
      costumeID
      createdAt
      deliveryStatus
      description
      gender
      id
      isVIP
      masqID
      paymentStatus
      section
      sectionOptType
      shelf {
        id
        name
        shelfId
        shelfDeliveryStatus
        updatedAt
        createdAt
      }
      wristBand {
        id
      }
      user {
        fullName
        firstName
        lastName
        image
        phoneNumbers {
          number
          type
        }
        role {
          name
          uuid
        }
        email
        accountStatus
      }
      boxtxes {
        action
        id
        createdAt
        shelf {
          band {
            id
            name
            schedules {
              eventEndTime
              eventStartTime
            }
          }
          name
        }
        user {
          email
          firstName
          fullName
          image
          lastName
        }
      }
      shippingDetails {
        isOpted
        provider
        shippingAddress
        status
        trackingID
      }
    }
    enum_shippingProviders
  }
`;
